// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createQuote } from "@flip/App/Services/QuoteService";
import { CustomAppState } from "@flip/App/Store/Reducers";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CreateOrRequestQuote,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";

export const xCreateOrRequestQuote: typeof CreateOrRequestQuote = async props => {
    const quoteItemsOnly = (props.getState() as CustomAppState).xRequestQuote.quoteItemsOnly;
    const { parameter, apiParameter } = props;
    const result = await createQuote(apiParameter, quoteItemsOnly);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        parameter.onError?.(result.errorMessage);
        return false;
    }
};

replaceInChain(chain, CreateOrRequestQuote, xCreateOrRequestQuote);
